
















































































































































import _ from "lodash";
import moment from "moment";
import { ControleVehiculeApi } from "../api/ControleVehiculeApi";
import ControleDetailModal from "./ControleDetailModal.vue";
import ExportButton from "../core/UI/ExportButton.vue";

export default {
    name: "ControlesList",
    components: { ControleDetailModal, ExportButton },
    data() {
        return {
            controles: [],
            vehicules: [],
            filterVehiculeId: null,
            filterEmployeId: null,
            loading: false,
            api: new ControleVehiculeApi(),
            selectedControle: null,
            showDetailModal: false,
        };
    },
    created() {
        this.api.getFlotte({ all: 1 }).then((res) => (this.vehicules = res));
        this.load();
    },
    computed: {
        // Seuls les employés effectivement affectés à un véhicule de la flotte
        // sont proposés dans le filtre chauffeur (dédoublonnés par id).
        employes() {
            let byId = {};
            this.vehicules.forEach((v) => {
                if (v.chauffeur_id && !byId[v.chauffeur_id]) {
                    byId[v.chauffeur_id] = {
                        id: v.chauffeur_id,
                        fullName: v.chauffeur_nom,
                    };
                }
            });
            return _.sortBy(Object.values(byId), "fullName");
        },
    },
    methods: {
        formatDate(date) {
            if (!date) {
                return "";
            }
            return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
        },
        getExportParams() {
            let params: any = {};
            if (this.filterVehiculeId) {
                params.vehicule_id = this.filterVehiculeId;
            }
            if (this.filterEmployeId) {
                params.employe_id = this.filterEmployeId;
            }
            return params;
        },
        load() {
            this.loading = true;
            let params: any = {};
            if (this.filterVehiculeId) {
                params.vehicule_id = this.filterVehiculeId;
            }
            if (this.filterEmployeId) {
                params.employe_id = this.filterEmployeId;
            }
            this.api.getControles(params).then((res) => {
                this.controles = res;
                this.loading = false;
            });
        },
        openDetail(controle) {
            this.selectedControle = controle;
            this.showDetailModal = true;
        },
        openPdf(controle) {
            this.api.openInNewTab(this.api.pdfUrl(controle.id));
        },
        onControleDeleted() {
            this.showDetailModal = false;
            this.load();
        },
        openPlanGarages(vehiculeId) {
            let id = typeof vehiculeId === "number" ? vehiculeId : null;
            this.api.openInNewTab(this.api.planGaragesUrl(id));
        },
    },
    watch: {
        filterVehiculeId() {
            this.load();
        },
        filterEmployeId() {
            this.load();
        },
    },
};
